
import { Component, Mixins, Prop } from "vue-property-decorator";
import { ModelEditableMixin, MouseTrackableMixin } from "../../../../../../../base/components/system/mixins";
import { FormatPageStructureEditableMixin } from "../../../mixins";

@Component
export default class FormatPageMouseTrackableMixin extends Mixins(ModelEditableMixin, FormatPageStructureEditableMixin, MouseTrackableMixin) {
  @Prop()
  pageElement: HTMLDivElement;
}
